import { LuCalendar, LuLayoutDashboard, LuListChecks, LuListTodo, LuMessageSquare } from "react-icons/lu";
import { APP_URLS } from "../../../config";

export const COMMON_MENU = [
    {
        title: 'Dashboard',
        icon: LuLayoutDashboard,
        path: APP_URLS.DASHBOARD,
        hasSubMenu: false
    },
    {
        title: 'My Attendance',
        icon: LuListChecks,
        path: APP_URLS.ATTENDANCE.ROUTE,
        hasSubMenu: false
    },
    {
        title: 'My Leaves',
        icon: LuListTodo,
        path: APP_URLS.LEAVES.ROUTE,
        hasSubMenu: false
    },
    {
        title: 'My Calendar',
        icon: LuCalendar,
        path: APP_URLS.CALENDAR.ROUTE,
        hasSubMenu: false
    },
    {
        title: 'Message',
        icon: LuMessageSquare,
        path: APP_URLS.CONVERSATION.ROUTE,
        hasSubMenu: false
    },
]